export enum PersonalInformationSharingContentType {
  Email = 'email',
  Phone = 'phone',
}
